<!-- 隐私政策历史版本 -->
<template>
  <div class="wraper">
    <div style="white-space:pre-wrap">
    <div class="top_title big">《隐私政策》历史版本</div>
    <div class="list_item">
      <div class="dot"></div>
      <div @click="goBack" class="right mark">当前版本</div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    goBack() {
      this.$emit("goCurrentVersion");
    }
  }
}
</script>
<style lang="less" scoped>
.wraper{
  width: 100%;
  height: 100%;
  padding: 46px 37px;
  box-sizing: border-box;
  font-size: 14px;
  color: #252945;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
  word-break: break-all;
  .list_item{
    margin-top: 32px;
    padding-left: 50px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .dot{
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #000000;
      margin-left: 8px !important;
      margin-right: 14px !important;
    }
  }
  .mark{
    color:#DC1E32;
    cursor: pointer;
  }
  .big{
    font-weight: 600;
  }
}
</style>